import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { LogOut, User, Bell, Shield, HelpCircle, MapPin, ChevronRight } from 'lucide-react';

export default function SettingsPage() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background pb-20">
      <header className="bg-card border-b px-4 py-3">
        <h1 className="text-xl font-semibold">Settings</h1>
      </header>

      <main className="p-4">
        <div className="space-y-4 max-w-2xl mx-auto">
          {/* Account Section */}
          <div className="bg-card rounded-lg border">
            <div className="p-4 border-b">
              <h2 className="font-semibold text-sm text-muted-foreground">ACCOUNT</h2>
            </div>
            
            <button className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors border-b">
              <User className="w-5 h-5 text-muted-foreground" />
              <span>Profile Settings</span>
            </button>
            
            <button className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors">
              <Bell className="w-5 h-5 text-muted-foreground" />
              <span>Notifications</span>
            </button>
          </div>

          {/* App Section */}
          <div className="bg-card rounded-lg border">
            <div className="p-4 border-b">
              <h2 className="font-semibold text-sm text-muted-foreground">APP</h2>
            </div>
            
            <button className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors border-b">
              <Shield className="w-5 h-5 text-muted-foreground" />
              <span>Privacy & Security</span>
            </button>
            
            <button className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors">
              <HelpCircle className="w-5 h-5 text-muted-foreground" />
              <span>Help & Support</span>
            </button>
          </div>

          {/* Developer Section */}
          <div className="bg-card rounded-lg border">
            <div className="p-4 border-b">
              <h2 className="font-semibold text-sm text-muted-foreground">DEVELOPER</h2>
            </div>
            
            <button 
              onClick={() => navigate('/debug/location')}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors"
            >
              <MapPin className="w-5 h-5 text-orange-500" />
              <span>Location Health</span>
              <span className="ml-auto text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded">DEBUG</span>
              <ChevronRight className="w-4 h-4 text-muted-foreground" />
            </button>
          </div>

          {/* Sign Out Button */}
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 bg-card rounded-lg border hover:bg-red-50 hover:border-red-200 transition-colors text-red-600"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Sign Out</span>
          </button>
        </div>
      </main>
    </div>
  );
}











